import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=2faf62c7&scoped=true"
import script from "./page7.vue?vue&type=script&lang=js"
export * from "./page7.vue?vue&type=script&lang=js"
import style0 from "./page7.vue?vue&type=style&index=0&id=2faf62c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf62c7",
  null
  
)

export default component.exports